<template>
  <div :class="'popover top in editable-container editable-popup ' + hideClass" :style="style">
      <div class="arrow" style="top: 6%; left:0; margin-left:-16px; transform: rotate(90deg)"></div>
      <h3 class="popover-title">
        {{titleInfo}}
          <i class="material-icons pointer-cursor-edit-name" @click="closePopup">
          clear
          </i>
      </h3>
      <div class="popover-content"><div>
        <div class="editableform-loading" style="display: none;"></div>
        <div class="form-group" v-if="errors.length" >
          <ul class="list-group">
            <li class="list-group-item list-group-item-danger" v-for="error in errors" :key="error">{{ error }}</li>
          </ul>
        </div>
        <div class="form-group" v-if="productGroupItems.length" >
          <table class="table">
            <thead>
              <tr>
                <th >Nazwa</th>
                <th >Kolor</th>
                <th >Ilość</th>
                <th >Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in productGroupItems" :key="`${item.productName}-${item.colorName}`">
                <td >{{ item.productName }}</td>
                <td>{{ item.colorName }}</td>
                <td class="text-center">{{ item.availability }}</td>
                <td :class="statusClass(item.productStatus)">{{ statusText(item.productStatus) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</template>
<script>

import uns from "underscore.string"
import userService from '@/service/userService'
import axios from 'axios'
import appConfig from '@/service/config'
import un from 'underscore'

export default {
  name: "ProductGroupPopup",
  data: () => ({
    popupStyle: "display: block;",
    title: "",
    hide: true,
    item: {
      id: -1
    },
    productGroupItems: [],
    errors: []
  }),
  created() {
    this.$eventHub.$on('showProductGroupPopup', this.onShowProductGroupPopup);
    this.$eventHub.$on('paginationClicked', this.onPaginationClicked);
  },
  mounted() {
  },
  destroyed() {
    this.$eventHub.$off('showProductGroupPopup');
    this.$eventHub.$off('paginationClicked');
    document.onkeydown = null
  },
  computed: {
    style() {
      return this.popupStyle
    },
    hideClass() {
      return this.hide ? "hide-popup" : ""
    },
    titleInfo() {
      var titleInfo = ""
      if (this.productGroupItems.length === 0) {
        titleInfo = ""
      } else if (this.productGroupItems.length > 0 ) {
        titleInfo = this.productGroupItems[0].brandName
      }
      return titleInfo;
    }
  },
  methods: {
    clearData() {
      this.productGroupItems = []
      this.item = {
        id: -1
      }
      this.title = ""
    },
    statusClass(id) {
      return appConfig.getClassForStatus(id)
    },
    statusText(id) {
      return appConfig.getTextForStatus(id)
    },
    onPaginationClicked(payload) {
      this.closePopup()
    },
    assignCloseEvent() {
      document.onkeydown = null
      const that = this
      document.onkeydown = function(evt) {
          evt = evt || window.event;
          if (evt.keyCode == 27) {
              that.closePopup();
          }
      };
    },
    onShowProductGroupPopup(payload) {
      this.assignCloseEvent();
      this.loadGroupProducts(payload);
      this.errors = []
      this.item = payload.product
      this.setPosition(payload.rect)
    },
    loadGroupProducts(payload) {
      const productId = payload.product.id
      const currentStoreId = userService.getCurrentStore()
      const req = axios({
        method: 'post',
        url: appConfig.baseUrl + '/products/group',
        data: {
          productId: productId,
          currentStoreId: currentStoreId
        },
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        this.title = res.data.productName
        this.productGroupItems = res.data.productGroupItems
      }).catch(err => {
        console.log(err);
        this.errors = un.map(err.response.data.errors, item => {
          return item.defaultMessage
        })
      })
    },
    setPosition(rect) {
      const top = rect.top + window.scrollY + 5;
      const left = rect.left + rect.width;
      this.popupStyle = "display: block; top:" + top + "px; left: " + left + "px;";
      this.hide = false
    },
    closePopup() {
      this.clearData()
      document.onkeydown = null
      this.hide = true
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/utils/ProductGroupPopup.vue